import React, { useState, useEffect, useCallback } from "react";
import "./challenge.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faEarthAmericas,
  faCirclePlus,
} from "@fortawesome/free-solid-svg-icons";
import PrincipalTemplate from "../commons/template/principalTemplate";
import { t } from "i18next";
import { ChallengeService } from "./challenge.service";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLogin } from "../../hooks/useLogin";
import ChallengeItem from "./components/challengeItem";
//import PackItem from "./components/packItem";
//import PackForm from "./components/pack-form";

export default function Challege() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { getUrlPage } = useLogin();
  const [openMenu, setOpenMenu] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [errorMessages, setErrorMessages] = useState([]);
  const [showModal, setShowModal] = useState(false);

  const getData = useCallback(async () => {
    try {
      const data = await ChallengeService("GET");
      setDataList(data);
      console.log("data", data);
    } catch (error) {
      if (error.message === "exit") {
        navigate("/");
      } else if (error) {
        setErrorMessages(error);
      }
    }
  }, []);

  useEffect(() => {
    (async () => {
      getData();
    })();
  }, []);

  const leftButton = () => {
    return (
      <FontAwesomeIcon
        icon={faBars}
        className="icon-facebook step-item-4"
        onClick={() => {
          setOpenMenu(true);
        }}
      />
    );
  };
  const rightButton = () => {
    return (
      <FontAwesomeIcon
        icon={faEarthAmericas}
        className="icon-facebook"
        onClick={() => {
          window.open(getUrlPage());
        }}
      />
    );
  };

  return (
    <PrincipalTemplate
      headerLeft={leftButton()}
      headerRight={rightButton()}
      menuAction={setOpenMenu}
      menuActive={openMenu}
      headerTitle={t("Desafios")}
      footerActive="pack"
    >
      <div className="offer-btn-plus">
        <FontAwesomeIcon
          icon={faCirclePlus}
          className="icon-plush"
          onClick={() => {
            setShowModal(true);
          }}
        />
      </div>
       {/* <PackForm
        value={{ name: "", description: "" }}
        showModal={showModal}
        setShowModal={setShowModal}
        onChange={(item) => {
          setDataList([item, ...dataList]);
        }}
      /> */}
   
    
    
    
      <div className="container-offer">
        {dataList &&
          dataList.map((item, index) => {
            return <ChallengeItem data = {item} key={index} />
           // return <PackItem key={index} data={item}/>
           // return <OffertItem key={index} data={item} />;
          })}
      </div> 
      <br />
      <br />
      <br />
      <br />
    </PrincipalTemplate>
  );
}
